import { keyframes } from '@mui/material';

/**
 * Keyframes for a simple opacity blink (50% → 0.3). Used for "live" indicators
 * (e.g. LiveDot, YoutubeLiveCounter). The keyframes are registered by MUI
 * when used; reference this in `animation` with the desired duration.
 */
export const blinkerKeyframes = keyframes`
  50% {
    opacity: 0.5;
  }
`;

/** Full animation string: blinker 1s linear infinite. Use in sx.animation. */
export const blinkerAnimation = `${blinkerKeyframes} 1s linear infinite`;

/**
 * Keyframes for two quick blinks (opacity 1 → 0.35 → 1) then stop.
 * Used for newly added list items when the user is at the top.
 */
export const blinkTwiceKeyframes = keyframes`
  0%, 100% { opacity: 1; }
  25% { opacity: 0.3; }
  50% { opacity: 1; }
  75% { opacity: 0.3; }
`;

/** Animation string: blink twice in 0.8s, run once. Use in sx.animation. */
export const blinkTwiceAnimation = `${blinkTwiceKeyframes} 2s ease-in-out 1`;
